import React, {useState} from 'react'
import axios from 'axios'

function Test() {
    const [text, setText ] = useState('text')
    const [data, setData ] = useState('text')

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            await axios.post('http://localhost:4000/sendmail', {
                text,
                data
            })
            console.log('Email Sent');
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <div>
            <form onSubmit={handleSubmit}>
                <input type="text" placeholder="text" name="text" onChange={e => setText(e.target.value)}/>
                <textarea placeholder="Data" name="text" onChange={e => setData(e.target.value)}/>
                <input type="submit" name="submit" value="Submit" className="btn btn-success"/>
            </form>
        </div>
    )
}

export default Test
